import IconAsMaskImage from "../IconAsMaskImage";

function FileUpload({ pureSvg, className, color }) {
  const svg = (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.384 8.38369V12.4235C18.384 16.4634 16.7681 18.0793 12.7282 18.0793H7.88041C3.84055 18.0793 2.22461 16.4634 2.22461 12.4235V7.57572C2.22461 3.53586 3.84055 1.91992 7.88041 1.91992H11.9203"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3837 8.38369H15.1518C12.7279 8.38369 11.9199 7.57572 11.9199 5.15181V1.91992L18.3837 8.38369Z"
        stroke="#667085"
        strokeWidth="1.21196"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  if (pureSvg) return svg;

  return <IconAsMaskImage {...{ svg, className, color }} />;
}

export default FileUpload;
